// DynamicNavItem.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  UpOutlined,
  DownOutlined,
  FolderFilled
} from "@ant-design/icons";
import { ListItemButton, ListItemIcon, ListItemText, Typography, List, Divider,Collapse  } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Avatar, Chip } from "@mui/material";
import { activeItem } from "store/reducers/menu";
import { ListIcon } from "menu-items/icons";



const DynamicNavItem = ({ item, level }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const menu = useSelector((state) => state.menu);
  const { drawerOpen, openItem } = menu;
  const [open, setOpen] = useState(false);
  const [openPest,setPestOpen] = useState(true);
  const [openDisease,setDiseaseOpen] = useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const handlePestClick = () => {
    setPestOpen(!openPest);
  };

  const handleDiseaseClick = () => {
    setDiseaseOpen(!openDisease);
  };



  const itemTarget = "_self";

  const listItemProps = {
    component: Link,
    // to: item.url,
    target: itemTarget,
    sx: {
      pl: drawerOpen ? `${level * 28}px` : 1.5,
      py: !drawerOpen && level === 1 ? 1.25 : 1,
      zIndex: 1201,
      ...(drawerOpen && {
        "&:hover": {
          bgcolor: "primary.lighter",
        },
        "&.Mui-selected": {
          bgcolor: "primary.lighter",
          borderRight: `2px solid ${theme.palette.primary.main}`,
          color: "primary.main",
          "&:hover": {
            color: "primary.main",
            bgcolor: "primary.lighter",
          },
        },
      }),
      ...(!drawerOpen && {
        "&:hover": {
          bgcolor: "transparent",
        },
        "&.Mui-selected": {
          "&:hover": {
            bgcolor: "transparent",
          },
          bgcolor: "transparent",
        },
      }),
    },
  };

  const itemHandler = (id) => {
    dispatch(activeItem({ openItem: [id] }));
  };

  const Icon = item.icon;
  const itemIcon = <Icon style={{ fontSize: drawerOpen ? "1rem" : "1.25rem" }} />
 

  const isSelected = openItem.findIndex((id) => id === item.id) > -1;

  // active menu item on page load
  useEffect(() => {
    const currentIndex = document.location.pathname
      .toString()
      .split("/")
      .findIndex((id) => id === item.id);
    if (currentIndex > -1) {
      dispatch(activeItem({ openItem: [item.id] }));
    }
    // eslint-disable-next-line
  }, []);

  const textColor = "text.primary";
  const iconSelectedColor = "primary.main";

  return (
    <>

<ListItemButton
  sx={{
    zIndex: 1201,
    pl: drawerOpen ? `${level * 28}px` : 1.5,
    py: !drawerOpen && level === 1 ? 1.25 : 1,
    ...(drawerOpen && {
      "&:hover": {
        bgcolor: "primary.lighter",
      },
      "&.Mui-selected": {
        bgcolor: "primary.lighter",
        borderRight: `2px solid ${theme.palette.primary.main}`,
        color: iconSelectedColor,
        "&:hover": {
          color: iconSelectedColor,
          bgcolor: "primary.lighter",
        },
      },
    }),
    ...(!drawerOpen && {
      "&:hover": {
        bgcolor: "transparent",
      },
      "&.Mui-selected": {
        "&:hover": {
          bgcolor: "transparent",
        },
        bgcolor: "transparent",
      },
    }),
  }}
 {...listItemProps} 
 selected={isSelected}
 onClick={() => {handleClick(); itemHandler(item.id) }} >
  {itemIcon && (
        <ListItemIcon
          sx={{
            minWidth: 28,
            color: isSelected ? iconSelectedColor : textColor,
            ...(!drawerOpen && {
              borderRadius: 1.5,
              width: 36,
              height: 36,
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                bgcolor: 'secondary.lighter'
              }
            }),
            ...(!drawerOpen &&
              isSelected && {
                bgcolor: 'primary.lighter',
                '&:hover': {
                  bgcolor: 'primary.lighter'
                }
              })
          }}
        >
          {itemIcon}
        </ListItemIcon>
      )}
<ListItemText primary={item.title} />
{open ? <UpOutlined /> : <DownOutlined />}
    </ListItemButton>
    <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <ListItemButton 
         sx={{
          zIndex: 1201,
          pl: drawerOpen ? `${level * 28}px` : 1.5,
          py: !drawerOpen && level === 1 ? 1.25 : 1,
          ...(drawerOpen && {
            "&:hover": {
              bgcolor: "primary.lighter",
            },
            "&.Mui-selected": {
              bgcolor: "primary.lighter",
              borderRight: `2px solid ${theme.palette.primary.main}`,
              color: iconSelectedColor,
              "&:hover": {
                color: iconSelectedColor,
                bgcolor: "primary.lighter",
              },
            },
          }),
          ...(!drawerOpen && {
            "&:hover": {
              bgcolor: "transparent",
            },
            "&.Mui-selected": {
              "&:hover": {
                bgcolor: "transparent",
              },
              bgcolor: "transparent",
            },
          }),
        }}
        {...listItemProps} onClick={() => {handlePestClick(); }}
  

         >   

          <ListItemText secondary={'Crop Insects'} />
          {openPest ? <UpOutlined /> : <DownOutlined />}
        </ListItemButton>
        <Collapse in={openPest} timeout="auto" unmountOnExit>
        
        {
            item.children.pests && (
            <List component="div" disablePadding>
                 {item.children.pests.map((pest) => (
                  <ListItemButton 
                  sx={{
                    zIndex: 1201,
                    pl: drawerOpen ? `${level * 28}px` : 1.5,
                    py: !drawerOpen && level === 1 ? 1.25 : 1,
                    ...(drawerOpen && {
                      "&:hover": {
                        bgcolor: "primary.lighter",
                      },
                      "&.Mui-selected": {
                        bgcolor: "primary.lighter",
                        borderRight: `2px solid ${theme.palette.primary.main}`,
                        color: iconSelectedColor,
                        "&:hover": {
                          color: iconSelectedColor,
                          bgcolor: "primary.lighter",
                        },
                      },
                    }),
                    ...(!drawerOpen && {
                      "&:hover": {
                        bgcolor: "transparent",
                      },
                      "&.Mui-selected": {
                        "&:hover": {
                          bgcolor: "transparent",
                        },
                        bgcolor: "transparent",
                      },
                    }),
                  }}
                  {...listItemProps} key={pest.id} 
                  
                  component={Link} to={pest.url} >
                     <ListItemText
                  primary={pest.name} 
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '210px', 
                  }}
                />
                  </ListItemButton>
                ))}
              </List>
            )
          }
          </Collapse>
          <ListItemButton  {...listItemProps}  onClick={() => {
             handleDiseaseClick();
  
  }}
    >   
          <ListItemText secondary={'Crop Diseases'} />
          {openDisease ? <UpOutlined /> : <DownOutlined />}
        </ListItemButton>
        <Collapse in={openDisease} timeout="auto" unmountOnExit>
        
        {
            item?.children?.diseases && (
            <List component="div" disablePadding>
                 {item.children.diseases.map((disease) => (
                  <ListItemButton  
                  sx={{
                    zIndex: 1201,
                    pl: drawerOpen ? `${level * 28}px` : 1.5,
                    py: !drawerOpen && level === 1 ? 1.25 : 1,
                    ...(drawerOpen && {
                      "&:hover": {
                        bgcolor: "primary.lighter",
                      },
                      "&.Mui-selected": {
                        bgcolor: "primary.lighter",
                        borderRight: `2px solid ${theme.palette.primary.main}`,
                        color: iconSelectedColor,
                        "&:hover": {
                          color: iconSelectedColor,
                          bgcolor: "primary.lighter",
                        },
                      },
                    }),
                    ...(!drawerOpen && {
                      "&:hover": {
                        bgcolor: "transparent",
                      },
                      "&.Mui-selected": {
                        "&:hover": {
                          bgcolor: "transparent",
                        },
                        bgcolor: "transparent",
                      },
                    }),
                  }}
                  {...listItemProps} key={disease.id} component={Link} to={disease.url} >
                    <ListItemText
                  primary={disease.name}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '210px', 
                  }}
                />
                            
                  </ListItemButton>
                ))}
              </List>
            )
          }
          </Collapse>
      </List>
    </Collapse>

    </>
  );
};

DynamicNavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number,
};

export default DynamicNavItem;
